import * as z from 'zod'

export const LoginSchema = z.object({
  userid: z.string({
    message: '필수 입력입니다.'
  }),
  password: z.string()
})

export const ResetSchema = z.object({
  user_id: z.string({
    message: '필수 입력입니다.'
  })
})
